/**
 * Purchasable object
 */
const yup = require('yup');

const {
  requiredString,
  validateObject,
  arrayOf,
  optionalString,
  requiredNumber,
  requiredBool
} = require('../utils');

const {
  purchasablePricingOption
} = require('../common');

const COLLECTION = 'purchasable';
const SCHEMA = yup.object().shape({
  title: requiredString(),
  description: optionalString(),
  downloadUrl: optionalString(),
  lastUpdated: optionalString(),
  path: optionalString(),
  per_location: requiredBool().default(false),
  pricing: arrayOf(purchasablePricingOption()),
  order: requiredNumber().default(0),
  membershipRequired: requiredBool().default(false)
});

async function validate(purchasable) {
  return validateObject(SCHEMA, purchasable);
}
/**
 * This object defines custom queries to perform on the data, outside of the normal CRUD operations
 */


const QUERIES = {};
/**
 * Methods added here will trigger https-callable Cloud Functions
 */

const CALLABLES = {};
/**
 * Methods added here will be appended to each returned document from the collection
 */

const MIXINS = {};
/**
 * Dates are a bit of a pitd with Firestore, so implement this method to convert any timestamp fields to JS Date objects
 * when records are inflated from Firestore, since ultimately we need to pass Date objects back to Firestore when saving
 * records
 * @param model The inflated object from Firestore
 * @returns the model with the appropriate Timestamps converted to JS Dates
 */

const convertDates = model => {
  return model;
};

module.exports = {
  QUERIES,
  CALLABLES,
  MIXINS,
  COLLECTION,
  SCHEMA,
  validate,
  convertDates
};